var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('main',{staticClass:"app-main"},[_c('div',{staticClass:"app-content"},[_c('main-content')],1)]),_c('footer',{staticClass:"app-footer"})])}
var staticRenderFns = []

export { render, staticRenderFns }